var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-create-ubl-archive-modal-wrapper",
    {
      attrs: { "is-purchase": _vm.isPurchase },
      on: {
        close: function ($event) {
          return _vm.close()
        },
      },
    },
    [
      _c(
        "w-card-content",
        [
          !_vm.filterOnVatPeriod
            ? _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "6" } },
                    [
                      _c("w-date-picker", {
                        attrs: { label: _vm.$ct("begin-date"), fancy: "" },
                        model: {
                          value: _vm.beginDate,
                          callback: function ($$v) {
                            _vm.beginDate = $$v
                          },
                          expression: "beginDate",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "6" } },
                    [
                      _c("w-date-picker", {
                        attrs: { label: _vm.$ct("end-date"), fancy: "" },
                        model: {
                          value: _vm.endDate,
                          callback: function ($$v) {
                            _vm.endDate = $$v
                          },
                          expression: "endDate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12", md: "12" } },
                [
                  _c("app-multi-select-journal", {
                    attrs: {
                      label: _vm.$ct("components.settings-default.journals"),
                      fancy: "",
                    },
                    model: {
                      value: _vm.journalIds,
                      callback: function ($$v) {
                        _vm.journalIds = $$v
                      },
                      expression: "journalIds",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.filterOnVatPeriod
            ? _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "12" } },
                    [
                      _c("w-input-number", {
                        attrs: {
                          decimals: "0",
                          label: _vm.$ct("vat-period"),
                          fancy: "",
                        },
                        model: {
                          value: _vm.vatPeriod,
                          callback: function ($$v) {
                            _vm.vatPeriod = $$v
                          },
                          expression: "vatPeriod",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-textarea", {
                    attrs: { label: _vm.$ct("ubl-archive-message"), fancy: "" },
                    model: {
                      value: _vm.message,
                      callback: function ($$v) {
                        _vm.message = $$v
                      },
                      expression: "message",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.cancel")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "check" },
              on: {
                click: function ($event) {
                  return _vm.create()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.confirm")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }